var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5208_6367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6943 0L45.6983 5.10933L54.369 5.09333L57.0317 13.344L64.0557 18.4267L61.361 26.6667L64.0557 34.9067L57.0317 39.9893L54.369 48.24L45.6983 48.224L38.6943 53.3333L31.6903 48.224L23.0197 48.24L20.357 39.9893L13.333 34.9067L16.0277 26.6667L13.333 18.4267L20.357 13.344L23.0197 5.09333L31.6903 5.10933L38.6943 0Z",
    fill: "#D0ECE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 5.33337L39.004 10.4427L47.6747 10.4267L50.3373 18.6774L57.3613 23.76L54.6667 32L57.3613 40.24L50.3373 45.3227L47.6747 53.5734L39.004 53.5574L32 58.6667L24.996 53.5574L16.3253 53.5734L13.6627 45.3227L6.63867 40.24L9.33334 32L6.63867 23.76L13.6627 18.6774L16.3253 10.4267L24.996 10.4427L32 5.33337Z",
    stroke: "#00955F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 32L29.3337 38.6667L42.667 25.3334",
    stroke: "#00955F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5208_6367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.172fd72f737cdae02f0458b0af89a6f7.svg";
export { ForwardRef as ReactComponent };